export const UI_NAME = 'ui-input';

export const SIZE_SMALL = 'small';
export const SIZE_MEDIUM = 'medium';
export const SIZE_LARGE = 'large';
export const SIZE_DEFAULT = SIZE_MEDIUM;

export const VALID = 'valid';
export const INVALID = 'invalid';

export const SIZES = [SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE];
